import styled from "styled-components/native";

export const HistoryContainer = styled.View`
  margin-top: 20px;
`;
